import { render } from "./TemplateDefault.vue?vue&type=template&id=35d3ab10&scoped=true"
import script from "./TemplateDefault.vue?vue&type=script&lang=js"
export * from "./TemplateDefault.vue?vue&type=script&lang=js"

import "./TemplateDefault.vue?vue&type=style&index=0&id=35d3ab10&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35d3ab10"],['__file',"src/layouts/TemplateDefault.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "35d3ab10"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('35d3ab10', __exports__)) {
    api.reload('35d3ab10', __exports__)
  }
  
  module.hot.accept("./TemplateDefault.vue?vue&type=template&id=35d3ab10&scoped=true", () => {
    api.rerender('35d3ab10', render)
  })

}


export default __exports__